import script from "./InfoForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoForm.vue?vue&type=script&lang=ts&setup=true"

import "./InfoForm.vue?vue&type=style&index=0&id=511bc312&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-511bc312"]])

export default __exports__